import {
  VALIDATE_PROMO_CODE_SUCCESS,
  VALIDATE_PROMO_CODE_FAIL,
} from "actions/stripe/promo";
import { CLEAR_PROMO } from "../../../actions/stripe/promo";

const initialState = Object.freeze({});

const getPromo = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_PROMO_CODE_SUCCESS:
      return action.data;
    case VALIDATE_PROMO_CODE_FAIL:
      return initialState;
    case CLEAR_PROMO:
      return initialState;
    default:
      return state;
  }
};

export default getPromo;
